import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import TodayIcon from '@mui/icons-material/Today'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import PeopleIcon from '@mui/icons-material/People'
import MenuIcon from '@mui/icons-material/Menu'
import useTelaPequena from './useTelaPequena'
import { useAuth } from '../../context/AuthContext'
import { podeAcessar } from '../../services/permissoes'

/** Evento que abre o menu lateral (BarraSuperiorEsquerda escuta). */
export const EVENTO_ABRIR_MENU = '4clinics:abrir-menu'

/** Altura da barra; telas com botão flutuante usam a variável CSS para subir o botão. */
export const ALTURA_BARRA = 56

const ITENS = [
  { valor: '/hoje', rotulo: 'Hoje', icone: <TodayIcon /> },
  { valor: '/agenda', rotulo: 'Agenda', icone: <CalendarMonthIcon /> },
  { valor: '/pacientes', rotulo: 'Pacientes', icone: <PeopleIcon /> },
]

/** A barra aparece só nas telas principais (nas demais o rodapé de ações ou o atendimento ocupam a base). */
const TELAS_COM_BARRA = ['/hoje', '/agenda', '/pacientes']

/**
 * Barra de navegação no rodapé do celular para o perfil profissional (F1; plano-front-atendimento.md F-D1):
 * Hoje · Agenda · Pacientes · Mais ("Mais" abre o menu atual). Desktop e demais perfis: sem barra.
 */
export default function BarraNavegacaoInferior() {
  const telaPequena = useTelaPequena()
  const { acesso } = useAuth()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const caminho = pathname.replace(/\/+$/, '') || '/'
  const visivel =
    telaPequena && acesso?.perfil === 'profissional' && podeAcessar(acesso, '/hoje') && TELAS_COM_BARRA.includes(caminho)

  // Botões flutuantes das telas sobem acima da barra (var CSS lida pela agenda e pela lista de pacientes)
  useEffect(() => {
    const raiz = document.documentElement
    if (visivel) raiz.style.setProperty('--nav-inferior', `${ALTURA_BARRA}px`)
    else raiz.style.removeProperty('--nav-inferior')
    return () => raiz.style.removeProperty('--nav-inferior')
  }, [visivel])

  if (!visivel) return null
  const itens = ITENS.filter((i) => podeAcessar(acesso, i.valor))
  const atual = itens.some((i) => i.valor === caminho) ? caminho : false

  return (
    <>
      {/* espaço para o conteúdo não ficar atrás da barra */}
      <div style={{ height: `calc(${ALTURA_BARRA}px + env(safe-area-inset-bottom))` }} aria-hidden="true" />
      <Paper
        component="nav"
        aria-label="Navegação principal"
        elevation={0}
        data-testid="barra-navegacao-inferior"
        sx={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: (t) => t.zIndex.appBar, pb: 'env(safe-area-inset-bottom)', borderTop: 1, borderColor: 'divider' }}
      >
        <BottomNavigation
          showLabels
          value={atual}
          onChange={(_, valor) => {
            if (valor === 'mais') window.dispatchEvent(new Event(EVENTO_ABRIR_MENU))
            else navigate(valor)
          }}
          sx={{ height: ALTURA_BARRA }}
        >
          {itens.map((i) => (
            <BottomNavigationAction key={i.valor} value={i.valor} label={i.rotulo} icon={i.icone} />
          ))}
          <BottomNavigationAction value="mais" label="Mais" icon={<MenuIcon />} />
        </BottomNavigation>
      </Paper>
    </>
  )
}
